import { Grid2 as Grid } from "@mui/material";
import { GridApi, GridReadyEvent, themeMaterial } from "ag-grid-community";

import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { useGridStyles } from "../../styles/gridStyles";
import { useTableData } from "../hooks/useTableData";
import { FailedStartupHeat } from "../models/FailedStartupHeat";

type Props = {
	rows: FailedStartupHeat[];
	isLoading: boolean;
	gridRef: React.RefObject<AgGridReact>;
};

export const FailedStartupTable = ({ isLoading, gridRef, rows }: Props) => {
	const [gridAPI, setGridAPI] = useState<GridApi | null>(null);
	const classes = useGridStyles();
	const { columnData, defaultColDef } = useTableData();

	const onGridReady = (params: GridReadyEvent) => {
		setGridAPI(params.api);
	};

	useEffect(() => {
		if (gridAPI) {
			if (isLoading) {
				gridAPI.showLoadingOverlay();
			} else {
				gridAPI.hideOverlay();
				gridAPI.setGridOption("rowData", rows);
			}
		}
	}, [gridAPI, isLoading, rows]);

	return (
		<div style={{ height: "70vh", width: "100%" }}>
			<Grid
				size={{ xs: 12 }}
				style={{
					height: "calc(100vh - 300px)",
					minHeight: "calc(100vh - 300px)",
					border: "1px solid #E0E0E0",
				}}
			>
				<div style={{ height: "100%", width: "100%" }}>
					<AgGridReact
						onGridReady={onGridReady}
						rowData={rows}
						columnDefs={columnData}
						rowSelection="single"
						overlayLoadingTemplate={"Loading..."}
						suppressContextMenu={true}
						getRowId={(params) => params.data.HeatName}
						ref={gridRef}
					/>
				</div>
			</Grid>
		</div>
	);
};
